import React, { useMemo, type ReactNode } from 'react';

import {
	parseNestedAdfDocument,
	type NestedAdfRendererWrapper,
} from '@confluence/macro-utils/entry-points/nestedAdfRenderer.ts';

export type BlogPostRichContentProps = {
	atlasDocFormat?: string | null;
	mediaToken?: string | null;
	contentId: string;
	spaceKey: string;
	spaceId?: string;
	RendererWrapper: NestedAdfRendererWrapper;
	fallback?: ReactNode;
};

export const BlogPostRichContent = ({
	atlasDocFormat,
	mediaToken,
	contentId,
	spaceKey,
	spaceId,
	RendererWrapper,
	fallback = null,
}: BlogPostRichContentProps): React.JSX.Element => {
	const adfDocument = useMemo(() => {
		return atlasDocFormat ? parseNestedAdfDocument(atlasDocFormat) : null;
	}, [atlasDocFormat]);

	if (adfDocument) {
		return (
			<RendererWrapper
				adf={adfDocument.content}
				targetContentId={contentId}
				targetSpaceKey={spaceKey}
				targetSpaceId={spaceId}
				mediaToken={mediaToken ?? undefined}
			/>
		);
	}

	return <>{fallback}</>;
};
